module.exports = __webpack_public_path__ + "media/evolve/assets/icons/planned/voicemail-313bdcd4ae11e8a8c1fa9da2401898a6.svg";